const TELEMETRY_PEAK_TIME_ALLOWED = [5, 10, 20, 22, 24, 29, 39] as const;
const SCAN_DWELL_TIME_ALLOWED = [1, 2, 3, 5, 10, 15, 20, 25, 30] as const;

export function sanitizeTelemetryPeakTime(value: number): number {
  const target = Number.isFinite(value) ? Math.round(value) : 22;
  let best: number = TELEMETRY_PEAK_TIME_ALLOWED[0];
  let bestDiff = Number.MAX_SAFE_INTEGER;
  for (const candidate of TELEMETRY_PEAK_TIME_ALLOWED) {
    const diff = Math.abs(candidate - target);
    if (diff < bestDiff) {
      best = candidate;
      bestDiff = diff;
    }
  }
  return best;
}

export function sanitizeScanDwellTime(value: number): number {
  const target = Number.isFinite(value) ? Math.round(value) : 3;
  let best: number = SCAN_DWELL_TIME_ALLOWED[0];
  let bestDiff = Number.MAX_SAFE_INTEGER;
  for (const candidate of SCAN_DWELL_TIME_ALLOWED) {
    const diff = Math.abs(candidate - target);
    if (diff < bestDiff) {
      best = candidate;
      bestDiff = diff;
    }
  }
  return best;
}
